export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 20;
export const MAX_PER_PAGE = 500;
export const ROWS_PER_PAGE = [5, 10, 20, 50];
